export default __webpack_public_path__ + "static/newlstter-image-7144380e644249730e1c6820870b777b.png";